export var XMLHttpRequestHandler_requestType;
(function (XMLHttpRequestHandler_requestType) {
    XMLHttpRequestHandler_requestType[XMLHttpRequestHandler_requestType["GET"] = 0] = "GET";
    XMLHttpRequestHandler_requestType[XMLHttpRequestHandler_requestType["POST"] = 1] = "POST";
})(XMLHttpRequestHandler_requestType || (XMLHttpRequestHandler_requestType = {}));
export class XMLHttpRequestHandler {
    // CONSTRUCTORS
    constructor(requestUrl, parameters, obj) {
        this.parameters = parameters;
        this.url = requestUrl;
        this.mode = XMLHttpRequestHandler_requestType.GET;
        this.onReadyStateFunction = function () { return; };
        this.obj = obj;
        this.request = new XMLHttpRequest();
        this.requestId = Math.random();
    }
    cancelAndReset() {
        if (this.request != null) {
            this.request.abort();
        }
        this.request = new XMLHttpRequest();
        this._requestId = Math.random();
    }
    // PROPERTIES
    get parameters() {
        return this._parameters;
    }
    set parameters(parameters) {
        this._parameters = parameters;
    }
    get requestId() {
        return this._requestId;
    }
    set requestId(requestId) {
        this._requestId = requestId;
    }
    get url() {
        return this._url;
    }
    set url(url) {
        this._url = url;
    }
    get request() {
        return this._request;
    }
    set request(request) {
        this._request = request;
    }
    get obj() {
        return this._obj;
    }
    set obj(obj) {
        this._obj = obj;
    }
    get mode() {
        return this._mode;
    }
    set mode(mode) {
        this._mode = mode;
    }
    get onReadyStateFunction() {
        return this._onReadyStateFunction;
    }
    set onReadyStateFunction(onReadyStateFunction) {
        this._onReadyStateFunction = onReadyStateFunction;
    }
    get requestStartTime() {
        return this._requestStartTime;
    }
    set requestStartTime(parameter) {
        this._requestStartTime = parameter;
    }
    execute() {
        var time = new Date().getTime();
        this.requestStartTime = time;
        let req_params = "";
        let p_separator = "?";
        for (let p of this.parameters) {
            req_params += p_separator + p[0] + "=" + encodeURIComponent(p[1]);
            p_separator = "&";
        }
        if (this._mode == XMLHttpRequestHandler_requestType.GET) {
            this.request.open("GET", this.url + req_params, true);
            this.request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            this.request.send();
        }
        else {
            this.request.open("POST", this.url, true);
            this.request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            this.request.send(req_params.substring(1));
        }
        this.request.onreadystatechange = this.onReadyStateFunction(this, this.obj);
    }
    execute_upload(file) {
        this.request.open("POST", this.url, true);
        let ext = file.name.slice((Math.max(0, file.name.lastIndexOf(".")) || Infinity) + 1);
        let newName = file.name.replace(/[^a-z\d\s]+/gi, "") + "." + ext;
        this.request.setRequestHeader("X-FILENAME", newName);
        this.request.send(file);
        this.request.onreadystatechange = this.onReadyStateFunction(this, this.obj);
    }
}
